import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import User from "@mapmycustomers/shared/types/User";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

const getAppliedFiltersCount = (
  filter: Partial<FilterModel>,
  viewAs: undefined | User["id"],
  implicitFilterFields?: IField[]
) => {
  const implicitFilterFieldsNames = new Set((implicitFilterFields ?? []).map(({ name }) => name));

  return (
    (viewAs ? 1 : 0) +
    Object.keys(filter).filter(
      (fieldName) => filter[fieldName] !== undefined && !implicitFilterFieldsNames.has(fieldName)
    ).length
  );
};

export default getAppliedFiltersCount;
